import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from '@increasecard/typed-components';
import { Link as RouterLink } from 'react-router-dom';

export interface BlockedCredentialsAlertProps {
  count: number;
}
export function BlockedCredentialsAlert({ count }: BlockedCredentialsAlertProps) {
  const { t } = useTranslation('credentials');
  return (
    <>
      {t('credentials:blockedCredentialsAlert:blockedCount', { count })}{' '}
      <Trans i18nKey="blockedCredentialsAlert:clickHereToResolve" ns="credentials">
        Haz click{' '}
        <Link as={RouterLink} to="/settings?action=blocked_credentials">
          aquí
        </Link>{' '}
        para solucionarlo
      </Trans>
    </>
  );
}
